<template>
  <b-media vertical-align="center">
    <template #aside>
      <b-avatar size="32" :text="avatarText(contact.name)" variant="light-primary" />
    </template>
    <span class="font-weight-bold d-block text-nowrap">
      {{ contact.name }}
    </span>
    <small class="text-muted">{{ contact.phone }}</small>
  </b-media>
</template>

<script>
import { avatarText } from '@core/utils/filter';
import { BAvatar, BMedia } from 'bootstrap-vue';
export default {
  name: 'PrimaryContactCell',
  components: {
    BAvatar,
    BMedia,
  },
  props: {
    contact: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      avatarText,
    };
  },
};
</script>
